import React, { PureComponent } from 'react'
import { onlyUpdateForKeys } from 'recompose'
import { withRouter } from 'react-router-dom'
import { Tabs, Tab } from 'material-ui/Tabs'
import { Row, Col } from 'pui-react-grids'
import { themeColors } from '../styles/theme'
import shrinked from './shrinked'
import Paper from 'material-ui/Paper'

const styles = {
  scotchTop: {
    height: '14px',
    marginTop: '-12px',
    backgroundColor: '#fff',
  },
  scotchBottom: {
    height: '14px',
    backgroundColor: '#fff',
  },
  tab: {
    color: themeColors.white,
  },
  inkBar: {
    //backgroundColor: themeColors.positive
  },
  tabsContainer: {
    backgroundColor: themeColors.positive,
  },
}

class SwapsTabs extends PureComponent {
  handleChange = type => {
    this.props.history.push(`/me/swaps/${type}`)
  }

  render() {
    const { type } = this.props
    return (
      <Row>
        <Col md={5} />
        <Col md={19}>

          {/* this div is needed to hide scroll under fixed tabs */}
          <div style={styles.scotchTop} className="hidden-xs" />

          <Paper zDepth={2}>
            <Tabs
              value={type}
              onChange={this.handleChange}
              tabItemContainerStyle={styles.tabsContainer}
              inkBarStyle={styles.inkBar}>

              <Tab label="In corso" value="proposte" style={styles.tab} />
              <Tab label="Accettate" value="accettate" style={styles.tab} />
              <Tab label="Concluse" value="archivio" style={styles.tab} />
            </Tabs>
          </Paper>

          {/* this div is needed to hide scroll under fixed tabs */}

        </Col>
      </Row>
    )
  }
}

export default withRouter(
  shrinked(onlyUpdateForKeys(['type'])(SwapsTabs), 'SwapsTabs')
)



// WEBPACK FOOTER //
// ./src/common/SwapsTabs.js